var map = {
	"./ADA.svg": 976,
	"./BCH.svg": 977,
	"./BNB.svg": 978,
	"./BTC.svg": 979,
	"./CHZ.svg": 980,
	"./DASH.svg": 981,
	"./DOGE.svg": 982,
	"./DOT.svg": 983,
	"./ETC.svg": 984,
	"./ETH.svg": 985,
	"./EUR.svg": 986,
	"./GBP.svg": 987,
	"./LINK.svg": 988,
	"./LTC.svg": 989,
	"./MATIC.svg": 990,
	"./MKR.svg": 991,
	"./SHIB.svg": 992,
	"./SOL.svg": 993,
	"./TRX.svg": 994,
	"./UNI.svg": 995,
	"./USD.svg": 996,
	"./USDT.svg": 997,
	"./XLM.svg": 998,
	"./XMR.svg": 999,
	"./XRP.svg": 1000,
	"./documents.svg": 1001
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 975;